<div>
    <app-messages />
    <router-outlet />
    <router-outlet name="mobile" />
</div>
